import { HOST_MAP, DEFAULT_APP_ENV } from '@/constants/constants';
import { initializeApp } from 'firebase/app';

// init firebase with relevant environment config
const appEnv = HOST_MAP[location.hostname] ?? DEFAULT_APP_ENV;
export const firebaseApp = initializeApp(appEnv.firebase);
